import styled from 'styled-components';

export const SISpecificationStyles = styled.section``;
